import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {Object} PayInvoiceParams
 * @property {string | number} paymentId
 * @property {string | number} amount
 * @property {string} source
 * @property {string} method
 * @property {string} reference_id
 * @property {File[]} [payment_proofs]
 * @property {string} currency
 */

export const usePayInvoice = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const { axiosInstance } = useAxios();

  /**
   * Pay invoice (manual payment)
   * @async
   * @param {PayInvoiceParams} params
   */
  const payInvoice = async ({
    paymentId,
    amount,
    source,
    method,
    reference_id,
    payment_proofs = [],
    currency,
  }) => {
    try {
      setLoading(true);
      setError("");
      setSuccess(false);

      const formData = new FormData();
      formData.append("amount", amount);
      formData.append("source", source);
      formData.append("method", method);
      formData.append("reference_id", reference_id);
      formData.append("currency", currency);

      payment_proofs.forEach((file) => {
        formData.append("payment_proofs[]", file);
      });

      const url = `${TENANT_DOMAIN}/billing/invoices/${paymentId}/pay`;

      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setSuccess(true);
      return response?.data;
    } catch (err) {
      setSuccess(false);

      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }

      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    payInvoice,
    loading,
    error,
    success,
  };
};
